module.exports = __webpack_public_path__ + "static/media/transformation.77be5301.svg";